import api from './api';

class CustomerInvoiceService {
    /**
     * Get customer's invoices with filters
     */
    async getMyInvoices(filters = {}) {
        try {
            const params = new URLSearchParams();

            if (filters.status) params.append('status', filters.status);
            if (filters.from_date) params.append('from_date', filters.from_date);
            if (filters.to_date) params.append('to_date', filters.to_date);
            if (filters.from_due_date) params.append('from_due_date', filters.from_due_date);
            if (filters.to_due_date) params.append('to_due_date', filters.to_due_date);
            if (filters.search) params.append('search', filters.search);
            if (filters.per_page) params.append('per_page', filters.per_page);
            if (filters.page) params.append('page', filters.page);

            const response = await api.get(`/customer/invoices?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching customer invoices:', error);
            throw error;
        }
    }

    /**
     * Get invoice details by ID
     */
    async getInvoiceDetails(invoiceId) {
        try {
            const response = await api.get(`/customer/invoices/${invoiceId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice details:', error);
            throw error;
        }
    }

    /**
     * Get invoice statistics for customer
     */
    async getInvoiceStats(filters = {}) {
        try {
            const params = new URLSearchParams();

            if (filters.from_date) params.append('from_date', filters.from_date);
            if (filters.to_date) params.append('to_date', filters.to_date);

            const response = await api.get(`/invoice-data/stats?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice stats:', error);
            throw error;
        }
    }
}

const customerInvoiceService = new CustomerInvoiceService();
export default customerInvoiceService;
